<template>
    <div class="main__section">
        <div class="detailedstep">
            <div class="detailedstep__form">
                <p class="detailedstep__title">According to your selected plan, you may select {{ maxCategoriesText() }} categories</p>

            <div class="detailedstep__input">
                <multiselect name="categories" id="categories"
                             :options="categoriesList"
                             :searchable="true"
                             :close-on-select="true"
                             :multiple="true"
                             placeholder="Search categories"
                             label="name"
                             :max="maxCategories"
                             track-by="id"
                             v-model="form.categories"
                             class="input__select">
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                </multiselect>
            </div>
                <div class="casete" v-for="(cat,index) in form.categories" :key="index">
                    <p>{{cat.name}}</p>
                </div>

                <div class="detailedstep__form">
                    <a href="#" class="button__next text-white mg-tp-45" @click.prevent="saveData()">Save</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        props: ['categories-list','max-categories','route', 'selected-categories'],
        components:{
            'multiselect':Multiselect,
        },
        data(){
            return{
                form:{
                    categories:[]
                },
                maxCategoriesText() {
                    return this.maxCategories == this.categoriesList.length ? 'unlimited' : 'up to ' + this.maxCategories;
                }
            }
        },
        methods:{
            saveData(){
                const self = this;
                axios.patch(this.route, {
                    categories: self.form.categories.map(c => c.id),
                })
                    .then(function (response) {
                        console.log(response);
                        if (response.data.success) {
                            window.location.reload(); // change to notification later
                        } else {
                            self.loading = false;
                        }
                    })
                    .catch(function (error) {
                        self.loading = false;
                    });
            },
        },
        created() {
            const self = this;
          this.maxCategories = this.maxCategories == 0 ? this.categoriesList.length : this.maxCategories;
          this.selectedCategories = JSON.parse(this.selectedCategories);
          this.selectedCategories.forEach(sc => {
             let c = self.categoriesList.find(x => x.id == sc);
             self.form.categories.push(c);
          });
        }
    }
</script>
